import { render, staticRenderFns } from "./listOfCriteria.vue?vue&type=template&id=708f9e44&"
import script from "./listOfCriteria.vue?vue&type=script&lang=js&"
export * from "./listOfCriteria.vue?vue&type=script&lang=js&"
import style0 from "./listOfCriteria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports